export const ugovor_o_preuzimanju_ispunjenja = {
  templateId: 25,
  category: 2,
  templateTitle: "Ugovor o preuzimanju ispunjenja",
  templateDescription: `Preuzimanje ispunjenja je ugovor kojim se treći (preuzimatelj ispunjenja) obvezuje dužniku da će ispuniti obvezu koju dužnik ima prema određenom vjerovniku. Za točniji odabir načina reguliranja međusobnih odnosa predlažemo da koristite <a target="_blank"  href="http://solucio-debit.com">Solucio Debit app</a>.`,
  description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p><strong>Preuzimanje ispunjenja je ugovor kojim se treći (preuzimatelj ispunjenja) obvezuje dužniku da će ispuniti njegovu obvezu prema koju ima prema određenom vjerovniku.</strong></p>
    <p>Ukoliko želite provjeriti hoće li ova vrsta ugovora biti ispravan odabir za međusobno reguliranje odnosa, predlažemo korištenje aplikacije <a target="_blank" href="http://solucio-debit.com">Solucio Debit app</a> koja će brzo i točno dati rješenje za vašu situaciju. </p>
    <p>Kod ugovora o preuzimanju ispunjenja, vjerovnik nije ugovorna strana (radi se o dvostranom ugovoru) te nema nikakva prava prema preuzimatelju ispunjenja, niti nikakve obveze.</p>
    <p>Važno je naglasiti da preuzimatelj ispunjenja ne preuzima dug, niti pristupa dugu, nego se samo obvezuje dužniku ispuniti njegovu obvezu prema vjerovniku.</p>
    <p>Dakle, preuzimatelj ispunjenja ne postaje dužnik vjerovnika.</p>
    <p>Preuzimatelj ispunjenja odgovara (za štetu) dužniku ako pravodobno ne ispuni obvezu vjerovniku te ovaj zatraži ispunjenje od dužnika.</p>
    <p><strong>Ipak, s druge strane, vjerovnik je dužan primiti ispunjenje od bilo koje osobe, u ovom slučaju od trećega (preuzimatelja ispunjenja).</strong></p>
    <p>Same ugovorne strane određuju vrstu i obujam odgovornosti treće osobe (preuzimatelja ispunjenja) prema dužniku.</p>
    <p>Ukoliko ne učine navedeno, primjenjuju se odredbe Zakona o obveznim odnosima koje određuju odgovornost za štetu.</p>

    <p><strong>NAPOMENA: Dužnik (poslovni subjekt) kojemu je blokiran račun odnosno koji ima oznaku zabranu raspolaganja oročenim novčanim sredstvima ne smije svoje obveze plaćati gotovim novcem, plaćati preko institucije za platni promet niti preko ostalih pružatelja platnih usluga u Republici Hrvatskoj, kao niti plaćati ili primati plaćanja preko računa otvorenog kod pružatelja platnih usluga u inozemstvu, a ne smije niti preusmjeravati novčane i financijske tijekove na drugu osobu niti primati uplate i isplaćivati novčana sredstva na račune drugih osoba.</strong><p>

    <h5>NAJČEŠĆE GREŠKE</h5>
   
    <p><strong>- Inzistiranje na potpisu vjerovnika</strong></p>
        <p>Pojašnjenje: vjerovnik ne potpisuje ugovor o preuzimanju ispunjenja jer se radi o dvostranom ugovoru između dužnika i preuzimatelja ispunjenja.</p>

    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o obveznim odnosima.</p>
  `,

  sides: [
    {
      prefix: "DUŽNIK:",
      signature: "DUŽNIK:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      delimiter: "i"
    },
    {
      prefix: "\r\nPREUZIMATELJ ISPUNJENJA:",
      signature: "PREUZIMATELJ ISPUNJENJA:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }
    ],
    suffix: ","
    },
  ],

  headline: "zaključuju sljedeći",
  title: "UGOVOR O PREUZIMANJU ISPUNJENJA",

  articles: [
    {
      title: "DUG DUŽNIKA",
      mandatory: true,
      statements: [
      
        {
          type: "input",
          editable: false,
          mandatory: true,
          parts: [
        
            {type: "text", content: "DUŽNIK ima nepodmireno dugovanje prema"},
            { type: "input", value: "", required: true, placeholder: "Naziv vjerovnika",},
                  { type: "text", content: "," },
            { type: "input", value: "", required: true,  placeholder: "Mjesto"  },
            { type: "text", content: "," },
            { type: "input", value: "", required: true,  placeholder: "Ulica i kućni broj"  },
            { type: "text", content: ", OIB:" },
            { type: "input", value: "", required: true,  placeholder: "Unesite OIB",},
            { type: "text", content: "(u daljnjem tekstu: VJEROVNIK), iznos od",  }, 
            { type: "input", value: '', required: true, help: "Unijeti iznos i valutu.",}, 
       
       
          ],
          }
        ]
      }, 
   
    {
      title: "PREDMET UGOVORA",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Sklapanjem ovog Ugovora, PREUZIMATELJ ISPUNJENJA se obvezuje DUŽNIKU pravodobno ispuniti njegovo dugovanje prema VJEROVNIKU u iznosu i opsegu preuzimanja ispunjenja određenog ovim Ugovorom."
        }
      ]
    },
    {
      title: "OPSEG PREUZIMANJA ISPUNJENJA",
      mandatory: true,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Ovim Ugovorom, PREUZIMATELJ ISPUNJENJA se obvezuje ispuniti dugovanje koje DUŽNIK ima prema VJEROVNIKU i to u cjelokupnom iznosu navedenom u ovom Ugovoru." }
              ]
            },
            {
              parts: [
                { type: "text", content: "Ovim Ugovorom, PREUZIMATELJ ISPUNJENJA se obvezuje djelomično ispuniti dugovanje koje DUŽNIK ima prema VJEROVNIKU i to u iznosu od" },
                { type: "input", value: "", help: "Ukoliko želite ugovoriti da Preuzimatelj ispunjenja preuzima ispunjenje samo dijela dugovanja iz ovog Ugovora, onda izaberite ovu opciju i unesite iznos.", required: true },
              ]
            }
          ],
        }
      ]
    },
   
    {
      title: "PRISTANAK VJEROVNIKA",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Za pravovaljanost ovog Ugovora nije potreban pristanak VJEROVNIKA."
        }
      ]
    },
    {
      title: "MJERODAVNO PRAVO",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Ugovorne strane suglasno utvrđuju da će se na sve odnose koji nisu riješeni ovim ugovorom primjenjivati odredbe važećih propisa Republike Hrvatske, a primarno odredbe Zakona o obveznim odnosima."
        }
      ]
    },
    {
      title: "NADLEŽNOST",
      mandatory: false,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom prema sjedištu DUŽNIKA." }
              ]
            },
            {
              parts: [
                { type: "text", content: "Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom prema sjedištu PREUZIMATELJA ISPUNJENJA." }
              ]
            },
            {
              parts: [
                { type: "text", content: "Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u " },
                { type: "input", value: "", help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true },
              ]
            }
          ],
        }
      ]
    },
    {
      title: "PRIMJENA UGOVORA",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Ugovor se primjenjuje od trenutka potpisa ugovornih strana."
        }
      ]
    },
    {
      title: 'PRIMJERCI UGOVORA',
      mandatory: false,
      statements: [
          {
              type: 'text',
              required: false,
              mandatory: true,
              editable: true,
              content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
              value: '',
          }],
    },
  {
    mandatory: true,
    static: true,
    type: 2, // date and place
    statements: [
      {
        type: "input",
        mandatory: true,
        parts: [
          {
            type: "text",
            content: "U"
          },
          {
            type: "input",
            value: "",
            placeholder: "Upišite mjesto.",
            required: true,
          },
          {
            type: "text",
            content: ", dana"
          },
          {
            type: "date",
            value: new Date(),
            required: true
          },
          {
            type: "text",
            content: "godine."
          }
        ]
      },
    ]
  },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
    },
  ],
}; 


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/25_ugovor_o_preuzimanju_ispunjenja.ts